import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../lib/analytics';
import { clarityTrackPageView } from '../lib/clarity';

// Hook for automatic page view tracking
export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page view on route change
    trackPageView(location.pathname + location.search, document.title);
    
    // Also track with Clarity
    clarityTrackPageView(location.pathname + location.search, document.title);
  }, [location]);
};

// Hook for component-level analytics
export const useComponentAnalytics = (componentName: string) => {
  useEffect(() => {
    // Track component mount
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', 'component_view', {
        event_category: 'Component Interaction',
        event_label: componentName,
        component_name: componentName,
        page_path: window.location.pathname,
        language: document.documentElement.lang || 'fr'
      });
    }
  }, [componentName]);

  return componentName;
};